import {
    BUSINESS_EVENTBRITE_CATEGORY,
    EVENTBRITE_CATEGORY_IMAGES,
    EVENTBRITE_CATEGORY_MAPPING,
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
    HEALTH_EVENTBRITE_CATEGORY,
    HOBBIES_EVENTBRITE_CATEGORY,
    MUSIC_EVENTBRITE_CATEGORY,
    PERFORMING_EVENTBRITE_CATEGORY,
    SEASONAL_EVENTBRITE_CATEGORY,
    SPORTS_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import {
    CategoryScrollTemplate,
    HorizontalSlider,
    HorizontalSliderCard,
} from '@eventbrite/category-scroll';
import { GenericLazyString } from '@eventbrite/i18n';
import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { HomepageImageCategoryBrowse } from '../../../../types';
import './ImageCategoryBrowse.scss';
export const ImageCategoryBrowse = ({ variant }: { variant: string }) => {
    interface Category {
        key: string;
        name: string | GenericLazyString;
        imageUrl: any;
    }

    const CATEGORY_KEYS = [
        MUSIC_EVENTBRITE_CATEGORY,
        PERFORMING_EVENTBRITE_CATEGORY,
        SEASONAL_EVENTBRITE_CATEGORY,
        HEALTH_EVENTBRITE_CATEGORY,
        HOBBIES_EVENTBRITE_CATEGORY,
        BUSINESS_EVENTBRITE_CATEGORY,
        FOOD_AND_DRINK_EVENTBRITE_CATEGORY,
        SPORTS_EVENTBRITE_CATEGORY,
    ];

    const CATEGORIES: Category[] = CATEGORY_KEYS.map((category) => {
        return {
            key: EVENTBRITE_CATEGORY_TO_REFINEMENT[category],
            name: EVENTBRITE_CATEGORY_MAPPING[category],
            imageUrl: EVENTBRITE_CATEGORY_IMAGES[category],
        };
    });

    return (
        <CategoryScrollTemplate wrappingClasses="sectionPadding">
            <HorizontalSlider cards={CATEGORIES}>
                {(category) => {
                    return (
                        <a
                            data-heap-id="homepage-category-tiles"
                            key={category?.key}
                            href={
                                variant ==
                                HomepageImageCategoryBrowse.values.varaint1
                                    ? `/b/local/${category?.key}`
                                    : `/d/local/${category?.key}--events/${category?.key}`
                            }
                            onClick={() => {
                                logEvent(
                                    'Homepage - All - Click - Trending Category',
                                );
                            }}
                        >
                            <HorizontalSliderCard
                                title={category?.name || ''}
                                imageUrl={category?.imageUrl}
                                imageLoading={'lazy'}
                            />
                        </a>
                    );
                }}
            </HorizontalSlider>
        </CategoryScrollTemplate>
    );
};
